import axios from "axios";
import BaseApi from "./baseApi";

export default class MachinesApi extends BaseApi {
  /*
   * Find machines by groupId
   */

  retrieveEntitlementsWithFallback(machine) {
    if (machine?.Entitlements && machine.Entitlements.length > 0) {
      machine.Activations = machine.Entitlements;
      delete machine.Entitlements;
    }
    return machine;
  }

  getMachinesByGroupId(groupId, search) {
    return axios
      .get(`${this.url}/api/${this.organizationCode}/machinegroups/${groupId}/machines`, {
        params: search
      })
      .then(response => {
        const machines_array = response.data.result.map(machine =>
          this.retrieveEntitlementsWithFallback(machine)
        );
        response.data.result = machines_array;
        return response.data;
      });
  }

  async saveActivation(machineId, params) {
    return await axios.post(
      `${this.url}/api/${this.organizationCode}/machines/${machineId}/activation`,
      params
    );
  }

  /**
  gets a single machine info by its id
  @param {string} organizationCode organization Id
  @param {string} machineId machine Id
  @returns {Promise} promise with machine data
  */
  async getMachineById(machineId) {
    return axios.get(`${this.url}/v2/machines/${machineId}`).then(response => {
      return this.retrieveEntitlementsWithFallback(response.data.result);
    });
  }

  async getMachineDataModel(machineId, limit = 1) {
    return this.getMachineDetail(machineId, "Machine/DataModel", limit);
  }

  async getMachineHmiName(machineId, limit = 1) {
    return this.getMachineDetail(machineId, "Machine/Hmi/Name", limit);
  }

  async getMachineDetail(machineId, channel, limit = 1) {
    const type = isInfoChannel(channel) ? "info" : "messages";
    return axios
      .get(`${this.url}/api/machines/${machineId}/${type}/${encodeURIComponent(channel)}`, {
        params: { limit }
      })
      .then(response => {
        return response.data.result;
      });
    //
    function isInfoChannel(c) {
      const infoChannels = [
        "Machine/Axes/[0-9]+/Type",
        "Machine/OperatingGroups/[0-9]+/Type",
        "Machine/OperatingGroups/[0-9]+/Model",
        "Machine/OperatingGroups/[0-9]+/Location",
        "Machine/OperatingGroups/[0-9]+/Subgroups/[0-9]+/Type",
        "Machine/OperatingGroups/[0-9]+/Subgroups/[0-9]+/Name",
        "Machine/AuxiliaryGroups/[0-9]+/Type",
        "Machine/AuxiliaryGroups/[0-9]+/Model",
        "Machine/DataModel",
        "Machine/Model",
        "Machine/Serial",
        "Machine/Type",
        "Machine/Cnc/Name",
        "Machine/Hmi/Name",
        "Machine/Hmi/SharedFolder"
      ];
      return new RegExp(infoChannels.join("|")).test(c);
    }
  }

  /**
  gets a single machine info by its id
  @param {string} machineId machine Id
  @returns {Promise} promise with machine data
  */
  async getMachineByIdNoVendor(machineId) {
    return axios.get(`${this.url}/api/machines/${machineId}`).then(response => {
      return this.retrieveEntitlementsWithFallback(response.data.result);
    });
  }

  /**
  gets a single machine info by its id
  @param {string} machineId machine Id
  @returns {Promise} promise with machine data
  */
  async patchMachineById(machineId, params) {
    return axios
      .patch(`${this.url}/v2/machines/${machineId}`, params)
      .then(response => response.data);
  }

  getMachines(search) {
    const query = {
      ...search
    };
    return axios.get(`${this.url}/v2/mymachines`, { params: query }).then(response => {
      const machines_array = response.data.result.map(machine =>
        this.retrieveEntitlementsWithFallback(machine)
      );
      response.data.result = machines_array;
      return response.data;
    });
  }

  getMachineGroupById(id) {
    return axios
      .get(`${this.url}/api/${this.organizationCode}/machinegroups/${id}`)
      .then(response => {
        return response.data.result;
      });
  }

  getUsersMachineGroupId(id, search) {
    return axios
      .get(`${this.url}/v2/${this.organizationCode}/machinegroups/${id}/users`, {
        params: search
      })
      .then(response => {
        return response.data.result;
      });
  }

  getGroups(search) {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/machinegroups", { params: search })
      .then(response => {
        return response.data;
      });
  }

  getMachineFamilies(vendorId) {
    return axios
      .get(this.url + `/api/organizations/${vendorId}/machinefamilies`, {})
      .then(response => {
        return response.data;
      });
  }

  saveMachineActivation(machineData) {
    return axios.post(this.url + "/api/oauth2/authorization", machineData).then(() => {
      return { data: machineData };
    });
  }

  saveMachineGroup(group) {
    return axios
      .post(this.url + "/v2/" + this.organizationCode + "/machinegroups", group)
      .then(response => {
        if (response && response.data && response.data.result) {
          return response.data.result;
        } else {
          return null;
        }
      });
  }

  updateMachineGroup(id, group) {
    return axios
      .put(this.url + "/api/" + this.organizationCode + "/machinegroups/" + id, group)
      .then(() => {});
  }

  updateMachinesOnGroup(id, group) {
    return axios.put(
      this.url + "/v2/" + this.organizationCode + "/machinegroups/" + id + "/machines",
      group
    );
  }

  deleteMachineGroup(id) {
    return axios.delete(this.url + "/v2/" + this.organizationCode + "/machinegroups/" + id);
  }

  getMachineConsumptions(machineId, from, to = undefined) {
    return axios
      .get(this.url + "/api/consumptions", {
        params: { machineId, from, to }
      })
      .then(response => {
        return response.data;
      });
  }
}

export const machinesApi = new MachinesApi();
